import { createSlice } from "@reduxjs/toolkit";
import { EditEmployeeProps } from "../types";

const initialState: EditEmployeeProps = {
  editEmpDtl: null,
};

const editEmpDtlReducer = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    setEditEmployeeDtl(state, action) {
      return {
        ...state,
        editEmpDtl: action.payload,
      };
    },
    updateEmployeeOfficialProf(state, action) {
      const { bonusStatus, payStatus } = action.payload;
      if (state.editEmpDtl && state.editEmpDtl.empOfficialProf) {
        state.editEmpDtl = {
          ...state.editEmpDtl,
          empOfficialProf: {
            ...state.editEmpDtl.empOfficialProf,
            BONUS_STATUS: bonusStatus,
            PAY_STATUS: payStatus,
          },
        };
      }
    },
  },
});

export default editEmpDtlReducer.reducer;

export const { setEditEmployeeDtl,updateEmployeeOfficialProf  } = editEmpDtlReducer.actions;
